module.exports = __webpack_public_path__ + "static/media/dove.429903c4.svg";